import React, { useState } from "react";
import axios from "axios";

function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        "https://cryptools-server-production.up.railway.app/api/login",
        { email, password }
      );
      const { token } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("isConnected", "yes");
      window.location.replace("/dashboard");
    } catch (error) {
      alert("Wrong email or password")
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col items-center gap-y-2 border-2 border-gray-200 rounded-md p-8 w-min m-auto">
      <label htmlFor="email">Email:</label>
      <input
        type="email"
        id="email"
        className="form-input shadow appearance-none border rounded w-50 my-1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <label htmlFor="password">Password:</label>
      <input
        type="password"
        id="password"
        className="form-input shadow appearance-none border rounded w-50 my-1 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button type="submit" className="py-2 px-5 rounded-lg font-medium text-white text-center bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-700 duration-150 block md:py-3 md:inline">Log In</button>
    </form>
  );
}

export default LoginForm;